// useSpeakingState — Phase 2.5a.
//
// Tracks whether the agent is currently speaking. voice_agent.html dispatches:
//   - concierge:audio_started  on the first PCM delta of a response
//   - concierge:audio_done     on response.output_audio.done
//   - concierge:interrupt      on barge-in (visitor speaks)
//
// Returns a boolean that the Orb component reads to decide whether to render
// in "speaking" mode (subtle scale + glow boost) or "idle" mode (slow breathe).

import { useEffect, useState } from 'react';

export function useSpeakingState(): boolean {
  const [speaking, setSpeaking] = useState(false);
  useEffect(() => {
    const onStart = () => setSpeaking(true);
    const onStop  = () => setSpeaking(false);
    window.addEventListener('concierge:audio_started', onStart);
    window.addEventListener('concierge:audio_done',    onStop);
    window.addEventListener('concierge:interrupt',     onStop);
    return () => {
      window.removeEventListener('concierge:audio_started', onStart);
      window.removeEventListener('concierge:audio_done',    onStop);
      window.removeEventListener('concierge:interrupt',     onStop);
    };
  }, []);
  return speaking;
}
